namespace $.$$ {
	export class $eve_segmented_option extends $.$eve_segmented_option {
	}
}
